import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Field from './forms/Field'
import LoadingIcon from './LoadingIcon'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Modal,
} from 'react-bootstrap'
import { sleep } from 'utils'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import routes from 'config/routes'

const schema = Yup.object().shape({
  title: Yup.string().required('Required'),
})

export function BankrollFilter({
  current,
  choices,
  onChange,
  onCreate,
  disabled,
}) {
  const history = useHistory()
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [creating, setCreating] = React.useState(false)

  const toggleModal = () => setShowNewModal(!showNewModal)

  const _create = async values => {
    try {
      setCreating(true)
      const [bankroll] = await Promise.all([onCreate(values), sleep(500)])
      toggleModal()
      history.push(routes.dashboard)
      onChange(bankroll)
    } catch (err) {
      setCreating(false)
      console.error('Error creating new bankroll')
      console.error(err)
    }
  }

  return (
    <>
      <div className="d-inline-block bankroll-filter m-1">
        <ButtonGroup>
          <DropdownButton
            as={ButtonGroup}
            variant="success"
            size="sm"
            id="range-filter"
            disabled={disabled}
            title="BANKROLL"
          >
            {choices.map(choice => (
              <Dropdown.Item
                key={choice.id}
                active={current.id === choice.id}
                onClick={() => onChange(choice)}
              >
                {choice.title}
              </Dropdown.Item>
            ))}
            <Dropdown.Divider />
            <Dropdown.Item onClick={toggleModal}>
              <FontAwesomeIcon icon="fa-regular fa-plus" fixedWidth />
              New Bankroll
            </Dropdown.Item>
          </DropdownButton>
          {current && (
            <Button variant="dark" size="sm" disabled>
              {current.title}
            </Button>
          )}
        </ButtonGroup>
      </div>
      <Modal show={showNewModal} onHide={toggleModal}>
        <Modal.Header
          closeButton
          className="border-0 text-success font-weight-bold"
        >
          NEW BANKROLL
        </Modal.Header>
        <Formik
          onSubmit={_create}
          validationSchema={schema}
          initialValues={{
            title: '',
          }}
        >
          {() => (
            <Form>
              <Modal.Body>
                <Field
                  label="Bankroll Name"
                  name="title"
                  placeholder="My New Bankroll"
                />
              </Modal.Body>
              <Modal.Footer className="border-0">
                <Button
                  variant="secondary"
                  disabled={creating}
                  onClick={toggleModal}
                >
                  Cancel
                </Button>
                <Button variant="warning" disabled={creating} type="submit">
                  {creating ? <LoadingIcon size="xs" /> : 'Add'}
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  )
}

BankrollFilter.propTypes = {
  disabled: PropTypes.bool,
  choices: PropTypes.array,
  onChange: PropTypes.func,
}

BankrollFilter.defaultProps = {
  disabled: false,
  choices: [],
  onChange: () => {},
  onCreate: () => {},
}

export default BankrollFilter
